var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("static-loading-indicator-icon", { attrs: { "with-card": true } }),
      _vm._v(" "),
      _c("transition", { attrs: { name: "component-fade", mode: "out-in" } }, [
        !_vm.$store.getters.isExecutingRequest
          ? _c(
              "div",
              [
                _c(
                  "page-header",
                  {
                    attrs: {
                      title: "Serie: " + _vm.series.title[_vm.$i18n.locale],
                      "icon-class": "mdi mdi-television"
                    }
                  },
                  [
                    _vm.$store.getters.isAdmin
                      ? _c(
                          "div",
                          { staticClass: "text-right" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "text-warning font-weight-bold",
                                attrs: {
                                  tag: "a",
                                  to: { name: "admin.series.edit" }
                                }
                              },
                              [
                                _c("i", { staticClass: "mdi mdi-pencil" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("actions.edit")) +
                                    "\n                    "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _vm.hasThumbnail
                  ? _c("img", {
                      staticClass: "img-fluid mb-4 rounded",
                      attrs: {
                        src: _vm.series.thumbnail_url,
                        alt: _vm.series.title[_vm.$i18n.locale]
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.series.description !== null
                  ? _c("div", { staticClass: "card mb-3" }, [
                      _c(
                        "div",
                        {
                          staticClass: "card-body shadow-sm",
                          staticStyle: { border: "1px solid black" }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.series.description[_vm.$i18n.locale]) +
                              "\n                "
                          )
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.series.videos && _vm.series.videos.length
                  ? _c("div", [
                      _c(
                        "div",
                        { staticClass: "row" },
                        _vm._l(_vm.series.videos, function(video) {
                          return _c(
                            "div",
                            {
                              key: video.id,
                              staticClass: "col-md-4 grid-margin"
                            },
                            [
                              _c("gym-video-card-new", {
                                attrs: {
                                  video: video,
                                  "page-link-enabled": true
                                }
                              })
                            ],
                            1
                          )
                        }),
                        0
                      )
                    ])
                  : _c("div", [
                      _c(
                        "div",
                        { staticClass: "alert alert-secondary border-dark" },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$t("pages.series.not_containing_videos")
                              ) +
                              "\n                "
                          )
                        ]
                      )
                    ])
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }